module.exports = __webpack_public_path__ + "img/36555-014.3387addb.jpg";